import { IOrgMember } from '@/types/IOrgMember';
import { ButtonGroup, Grid, IconButton, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FiTrash } from 'react-icons/fi';
import MemberRole from './components/member.role.component';

interface IProps {
	member: IOrgMember;
	onRemoveMember: (memberId: string) => Promise<void>;
}

export default function Member(props: IProps) {
	const { t } = useTranslation();

	return (
		<Grid
			bg="white"
			p={4}
			px={6}
			borderWidth={1}
			borderColor="gray.200"
			borderRadius="md"
			gridTemplateColumns="1fr auto auto"
			alignItems="center"
			gap={4}
		>
			<Text fontWeight="500" fontSize="md">
				{props.member.email}
			</Text>
			<Grid gap={2} alignItems="center">
				{props.member.roles.map((role) => (
					<MemberRole key={role} role={role} />
				))}
			</Grid>
			<ButtonGroup variant="ghost">
				<IconButton
					isRound
					aria-label={t('Remove')}
					onClick={() => props.onRemoveMember(props.member.id)}
					icon={<FiTrash />}
				/>
			</ButtonGroup>
		</Grid>
	);
}
